import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import GoogleMap from "google-map-react";
import { googleMapsStyle } from "../../../../helpers";
import Marker from "./Marker";

function createMapOptions(maps) {
    return {
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: { position: maps.ControlPosition.TOP_RIGHT },
        styles: googleMapsStyle,
        mapTypeControl: true,
        scrollwheel: false
    };
}

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data : props.data
        };
    }

    onChangeMap = (maps) => {

        if (this.props.onChangeMap) {
            this.props.onChangeMap(maps.center.lat, maps.center.lng)
        }

    }

    render() {
        let { data } = this.props;

        if (!data.latitude && !data.longitude) {
            data["latitude"] = 41.045930450756735
            data["longitude"] = 29.033413529100827;
        }

        return (

            <Fragment>

                <GoogleMap
                    bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                    onChange={(e) => this.onChangeMap(e)}
                    center={[data.latitude, data.longitude]}
                    yesIWantToUseGoogleMapApiInternals={true}
                    zoom={12}
                    style={{ width: 1250, height: 350 }}
                    options={createMapOptions}
                    draggable={true}
                />

                <Marker
                    key={"startMap-"}
                    claz="start-point"
                    lat={data.latitude}
                    lng={data.longitude}
                />

            </Fragment>

        );
    }
}

const mapStateToProps = ({ auth }) => ({ auth });
export default connect(mapStateToProps)(Map);



// WEBPACK FOOTER //
// ./src/components/App/components/GoogleMaps/Map.js